import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  getPartnerRegistration,
  postPartnerRegistration,
} from '../../api/constlink';
import PartnerRegistrationComponent from '../../components/partners/PartnerRegistrationComponent';
import PartnerRegistrationResultComponent from '../../components/partners/PartnerRegistrationResultComponent';
import { EmailInvitation, EmailInvitationStatus } from '../../modules/auth';
interface PartnerRegistrationContainerProps {
  enterpriseId: string;
}
function PartnerRegistrationContainer({
  match,
}: RouteComponentProps<PartnerRegistrationContainerProps>) {
  const { enterpriseId } = match.params;
  // const { sendEnterpriseId } = qs.parse(window.location.search, {
  //   ignoreQueryPrefix: true,
  // });
  const [emailInvitation, setEmailInvitation] = useState<EmailInvitation>();
  useEffect(() => {
    (async () => {
      setEmailInvitation(
        await getPartnerRegistration({
          enterpriseId,
        }),
      );
    })();
  }, [enterpriseId]);

  const _postPartnerRegistration = (status: EmailInvitationStatus) => {
    (async () => {
      setEmailInvitation(
        await postPartnerRegistration({
          enterpriseId,
          status,
        }),
      );
    })();
  };

  return (
    <>
      <>
        {emailInvitation &&
          emailInvitation.status === EmailInvitationStatus.INVITED && (
            <PartnerRegistrationComponent
              emailInvitation={emailInvitation}
              postPartnerRegistration={_postPartnerRegistration}
            />
          )}

        <PartnerRegistrationResultComponent emailInvitation={emailInvitation} />
      </>
    </>
  );
}

export default PartnerRegistrationContainer;
